import {isDev, isStage} from './common';
const pkg = require('../../package.json');

/**
 * https://straus-org.sentry.io/settings/projects/frontend/keys/
 */
export const SENTRY_DNS = 'https://b904a1ce7c2a456c9587b4915fc11b91@o1379059.ingest.sentry.io/6697586';

export const SENTRY_ENABLED = !(isDev || isStage);
export const SENTRY_RELEASE = 'straus@' + pkg.version;
/**
 * Here are all sentry ignores
 */
export const ignoreErrors = [
  // https://github.com/vercel/next.js/issues/43088
  'Invariant: attempted to hard navigate to the same URL',
  // https://github.com/getsentry/sentry-javascript/issues/2546
  'Non-Error exception captured',
  'Event `Event` (type=error) captured as promise rejection',
  // https://github.com/vuejs/vue-cli/issues/7431
  'ResizeObserver loop completed with undelivered notifications.',
  'Network Error',
  'timeout of 60000ms exceeded',
  'Request aborted',
  'Installations: Could not process request. Application offline. (installations/app-offline).',
  'Load failed',
  'AbortError: AbortError',
  'UnknownError: Database deleted by request of the user',
  `undefined is not an object (evaluating 'a.L')`,
  'Cancel rendering route', //https://medium.com/@nareshpingle/resolving-the-cancel-rendering-route-error-in-next-js-1b4c2494a325
  `Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.`,
  'The operation is insecure.', //sentry config
  'Cannot redefine property: googletag', //https://github.com/shadcn-ui/ui/issues/2837,
  `Unexpected token 'else'`,
  `undefined is not an object (evaluating 'n.length')`,
  `Non-Error promise rejection captured with value: Could not inject tron provider because it's not your default extension`,
  `Non-Error promise rejection captured with value: Could not inject ethereum provider because it's not your default extension`,
  'Request failed with status code 404',
  'OneSignal: This web push config can only be used on https://www.straus.md. Your current origin is https://straus.md.',
  't.$_Tawk.i18next is not a function',
  'Method not found',
];

/**
 * Unused urls
 */
export const denyUrls = [
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  /^chrome-extension:\/\//i,
];

/**
 * WDYR
 * Make sure to only include the library in development
 */
export const kWDYRenabled = false;
